import 'lazysizes';
import 'svgxuse';
import 'flickity';

// Individual Bootstrap components
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/tab';

// Site components
import ClassToggler from './modules/classtoggler';
import PrefetchLinks from './modules/prefetchlinks';
import Navigation from './modules/navigation';
import Scrolling from './modules/scrolling';
import FracTracking from './modules/fracs';
import Forms from './modules/forms';
import VideoPlayer from './modules/videoplayer';
import Tracking from './modules/tracking';

// Site styles
import '../css/app.scss';

// DOM ready:
$(() => {
	$('html').removeClass('no-js');

	// Init common modules
	ClassToggler.Init();
	Navigation.Init();
	FracTracking.Init();
	Forms.Init();
	Scrolling.Init();
	Tracking.Init();
	VideoPlayer.Init();
	PrefetchLinks.Init();
});

// All assets loaded
// $(window).on('load', () => { });
